import React, { useEffect, useState } from 'react';
import './HomePage.css';
import { Col, Row, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper, faBullhorn, faInfoCircle, faEnvelope, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import logoPath from "./../../assets/HPTI_3.png";
import Header from './../Header/Header';
import BASE_URL, { allNotifications } from '../Services/Employees';
import legacyExamResults from './legacyExamResults';
import axios from 'axios';

const HomePage = () => {
  const [whatsNew, setWhatsNew] = useState([]);
  const [publicNotice, setPublicNotice] = useState([]);
  const [results, setResults] = useState([]);

  useEffect(() => {
    allNotifications().then((response) => {
      setPublicNotice(response.data.PublicNotice || []);
      setWhatsNew(response.data.WhatNew || []);
      setResults(response.data.Result || []);
    }, (error) => {
    });
  }, []);

  const fetchDocument = (fileName) => {
    axios
      .get(BASE_URL + "/notifications/displayDocument", {
        responseType: "blob",
        params: {
          fileName: fileName
        }
      })
      .then((response) => {
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        const pdfWindow = window.open();
        pdfWindow.location.href = fileURL;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const renderResultLink = (key, heading, onClick, href, target) => (
    <div key={key}>
      <FontAwesomeIcon icon={faChevronRight} />
      <a
        style={{ textDecoration: "none", color: "green" }}
        href={href || "#"}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        onClick={onClick}
      >
        &nbsp;{heading}
      </a>
    </div>
  );

  return (
    <>
      <Header />

      <img src={logoPath} style={{ width: "100%" }} alt=""></img>
      <div className='container'>
        <Row className='text-start' >
          <Col sm="6" className="mt-2 px-1 " >
            <Card style={{ minHeight: "100%" }}>
              <CardBody >
                <CardTitle className='text-center' tag="h3"><FontAwesomeIcon icon={faNewspaper} className="icon" style={{ fontSize: "20px" }} /> What's New</CardTitle>
                <CardText>
                  {whatsNew.map((item, index) => (
                    <div key={index}>
                      <FontAwesomeIcon icon={faChevronRight} style={{ color: '' }} /><a style={{ textDecoration: "none", color: "green" }} href="#" onClick={(e) => { e.preventDefault(); fetchDocument(item.fileName); }} >&nbsp;{item.heading}</a>
                    </div>
                  ))}
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col sm="6" className="mt-2 px-1">
            <Card style={{}}>
              <CardBody>
                <CardTitle className='text-center' tag="h3"><FontAwesomeIcon icon={faBullhorn} className="icon" style={{ fontSize: "20px" }} /> Public Notice</CardTitle>
                <CardText>
                  {publicNotice.map((item, index) => (
                    <div key={index}>
                      <FontAwesomeIcon icon={faChevronRight} style={{ color: '' }} /><a style={{ textDecoration: "none", color: "green" }} href="#" onClick={(e) => { e.preventDefault(); fetchDocument(item.fileName); }}> &nbsp;{item.heading}</a>
                    </div>
                  ))}
                </CardText>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className='text-start'>
          <Col sm="6" className="mt-2 px-1">
            <Card style={{}}>
              <CardBody>
                <CardTitle className='text-center' tag="h3"><FontAwesomeIcon icon={faInfoCircle} className="icon" style={{ fontSize: "20px" }} /> About Us</CardTitle>
                <CardText>
                  <ul>
                    <p>The HVPN Power Training Institute (HPTI) is a State- of the-Art Institute of learning for officers/officials of Haryana Power Utilities (HPUs) in Technology and Management Sectors setup at Sector-26, Panchkula.

                      HPTI, Panchkula was registered under the Societies Registration Act, 1860 in the office of Registrar of Firms & Societies, Haryana vide Registration no. 28 of 2007-08 dated 05.05.2007 after getting approval of the Board of Directors, HVPNL in its meeting held on 28.03.2007 and was further re-registered under the Haryana Registration and Regulation of Societies Act, 2012 vide Registration No. 00735 dated 29.03.2017.</p>
                  </ul>
                </CardText>
              </CardBody>
            </Card>
          </Col>
          <Col sm="6" className="mt-2 px-1">
            <Card style={{ minHeight: "100%" }}>
              <CardBody>
                <CardTitle className="text-center" tag="h3">
                  <FontAwesomeIcon icon={faEnvelope} className="icon" style={{ fontSize: "20px" }} /> Exam Schedule/Result
                </CardTitle>
                <div style={{ maxHeight: "300px", overflowY: "auto", paddingRight: "8px" }}>
                  <CardText>
                    {results.map((item, index) =>
                      renderResultLink(
                        `uploaded-${index}`,
                        item.heading,
                        (e) => { e.preventDefault(); fetchDocument(item.fileName); }
                      )
                    )}
                    {legacyExamResults.map((item, index) =>
                      renderResultLink(
                        `legacy-${index}`,
                        item.heading,
                        undefined,
                        item.file,
                        "_blank"
                      )
                    )}
                  </CardText>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default HomePage;
